document.addEventListener('DOMContentLoaded', () => {

  const cards =
    document.querySelectorAll('.br-fabric-card');

  const previewImage =
    document.getElementById('br-preview-image');

  const selectedName =
    document.getElementById('br-selected-name');

  const selectedDesc =
    document.getElementById('br-selected-desc');

  cards.forEach(card => {

    card.addEventListener('click', () => {

      cards.forEach(c => {
        c.classList.remove('active');
      });

      card.classList.add('active');

      const image =
        card.dataset.image;

      previewImage.style.opacity = '0';
      previewImage.style.transform = 'scale(.97)';

      setTimeout(() => {

        previewImage.src = image;

        previewImage.style.opacity = '1';
        previewImage.style.transform = 'scale(1)';

      }, 250);

      selectedName.textContent =
        card.dataset.name;

      selectedDesc.textContent =
        card.dataset.desc;

    });

  });

});